export default () => ({
  isLoading: false,
  isError: {
    status: false,
    error: {}
  },
  fetchCompleted: false
})
